import { queryClient, getLanguage } from '../queriesUtil';

// keeping this local due to options are relavant to this file alone
const REACT_QUERY_OPTIONS = {
  staleTime: 3000,
};

export const fetchQuery = (queryKey, queryFetchFunction, options = REACT_QUERY_OPTIONS) => {
  // extend query key with query language
  const queryKeyWithLang = [getLanguage(), ...queryKey];

  if (typeof queryClient.getQueryData(queryKeyWithLang) !== 'undefined')
    return Promise.resolve(queryClient.getQueryData(queryKeyWithLang));
  return queryClient.fetchQuery(queryKeyWithLang, async () => queryFetchFunction, options);
};
